export default {
  metadata: {
    version: '1.0.0',
    id: 'dropdown-menu-item-1.0.0',
    name: 'JDSDropdownMenuItem'
  },
  hierarchy: {
    'root-container': [
      {
        container: [
          'jds_checkbox',
          {
            'prefix-container': ['prefix-slot']
          },
          {
            'content-container': ['label-jds-text', 'description-jds-text']
          },
          {
            'suffix-container': ['suffix-jds-text', 'icon']
          }
        ]
      },
      {
        jds_dropdown_menu_submenu: ['menu-group-slot']
      }
    ]
  },
  base: {
    'root-container': {
      hidden: false,
      width: '{d_24}'
    },
    container: {
      hidden: false,
      'flex-direction': '{d_1}',
      'align-items': '{d_16}',
      gap: '{d_3}',
      'background-color': '{d_4}',
      width: '{d_0}',
      'padding-top': '{d_8}',
      'padding-right': '{d_9}',
      'padding-bottom': '{d_10}',
      'padding-left': '{d_11}',
      opacity: '',
      behavior: {
        hover: {
          'background-color': '{d_5}'
        },
        active: {
          'background-color': '{d_6}'
        },
        focus: {
          'border-radius': '{d_23}'
        }
      }
    },
    'menu-group-slot': {
      hidden: false
    },
    'suffix-container': {
      hidden: false
    },
    'prefix-container': {
      hidden: false,
      'align-self': '{d_17}'
    },
    'prefix-slot': {
      hidden: false
    },
    'content-container': {
      hidden: false,
      flex: 1,
      overflow: 'hidden',
      'justify-content': '{d_14}',
      'align-items': '{d_15}',
      'flex-direction': '{d_2}'
    },
    icon: {
      size: '{d_19}',
      color: '{d_18}',
      value: 'ic_chevron_right',
      behavior: {
        active: {
          color: '{d_20}'
        }
      },
      hidden: true
    },
    jds_dropdown_menu_submenu: {
      hidden: true
    },
    jds_checkbox: {
      hidden: true
    },
    'label-jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      behavior: {
        active: {
          color: '{text_18}'
        }
      }
    },
    'description-jds-text': {
      'font-family': '{text_167}',
      color: '{text_20}',
      'font-size': '{text_166}',
      'line-height': '{text_168}',
      'letter-spacing': '{text_169}',
      'font-weight': '{text_170}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      behavior: {
        active: {
          color: '{text_18}'
        }
      }
    },
    'suffix-jds-text': {
      'font-family': '{text_167}',
      color: '{text_21}',
      'font-size': '{text_166}',
      'line-height': '{text_168}',
      'letter-spacing': '{text_169}',
      'font-weight': '{text_170}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      behavior: {
        active: {
          color: '{text_18}'
        }
      }
    }
  },
  variant: {
    kind: {
      'multi-select': {
        jds_checkbox: {
          hidden: false,
          checked: false
        },
        container: {
          behavior: {
            active: {
              'background-color': '{primaryGrey40}'
            }
          }
        },
        icon: {
          behavior: {
            active: {
              color: '{primaryGrey80}'
            }
          }
        },
        'label-jds-text': {
          behavior: {
            active: {
              color: '{text_2}'
            }
          }
        },
        'description-jds-text': {
          behavior: {
            active: {
              color: '{text_2}'
            }
          }
        },
        'suffix-jds-text': {
          behavior: {
            active: {
              color: '{text_2}'
            }
          }
        }
      }
    },
    _labelTextWrap: {
      false: {
        'label-jds-text': {
          'max-lines': 1,
          maxLines: 1
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{d_22}'
        }
      }
    },
    selected: {
      true: {
        jds_dropdown_menu_submenu: {
          hidden: false
        },
        container: {
          'background-color': '{d_12}',
          behavior: {
            hover: {
              'background-color': '{d_13}'
            }
          }
        },
        icon: {
          color: '{d_21}'
        },
        'label-jds-text': {
          color: '{text_18}'
        },
        'description-jds-text': {
          color: '{text_18}'
        },
        'suffix-jds-text': {
          color: '{text_18}'
        }
      }
    },
    _hasSubMenu: {
      true: {
        icon: {
          hidden: false
        },
        'suffix-jds-text': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      'multi-select': {
        true: {
          container: {
            'background-color': '{primaryGrey20}',
            behavior: {
              hover: {
                'background-color': '{primaryGrey20}'
              }
            }
          },
          icon: {
            color: '{primaryGrey80}'
          },
          'label-jds-text': {
            color: '{text_2}'
          },
          'description-jds-text': {
            color: '{text_2}'
          },
          'suffix-jds-text': {
            color: '{text_2}'
          }
        }
      }
    }
  ],
  combination_config: [['kind', 'selected']],
  api: {
    children: {
      'prefix-slot': {
        name: 'prefix',
        accepts: ['jds_image', 'jds_avatar', 'jds_icon'],
        max: 1
      },
      'menu-group-slot': {
        name: 'children',
        accepts: ['jds_dropdown_menu_group']
      }
    },
    events: {
      container: {
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        },
        onClick: 'onClick'
      },
      jds_checkbox: {
        onClick: 'onItemSelect'
      }
    },
    data: {
      jds_dropdown_menu_submenu: {
        offsetX: {
          type: 'string',
          name: '_offsetX'
        },
        offsetY: {
          type: 'string',
          name: '_offsetY'
        },
        children: {
          type: 'slot',
          name: 'children'
        }
      },
      jds_checkbox: {
        indeterminate: {
          type: 'boolean',
          name: '_indeterminate'
        },
        checked: {
          type: 'boolean',
          name: '_checked'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      'description-jds-text': {
        value: {
          type: 'string',
          name: 'description'
        }
      },
      'suffix-jds-text': {
        value: {
          type: 'string',
          name: 'suffix'
        }
      }
    },
    config: {
      kind: {
        values: ['single-select', 'multi-select']
      },
      selected: {
        values: [false, true]
      },
      disabled: {
        values: [false, true]
      },
      _hasSubMenu: {
        values: [false, true]
      },
      _labelTextWrap: {
        values: [true, false]
      }
    },
    a11y: {
      'root-container': {
        properties: {
          role: {
            value: 'menuitem'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-haspopup': {
            name: '_ariaHaspopup',
            prop: '_hasSubMenu'
          },
          'aria-expanded': {
            name: '_ariaExpanded',
            prop: 'selected'
          }
        }
      }
    }
  }
};
